/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type DeprecatedProjectIndicatorJS_project$ref = any;
type DraggableCard_task$ref = any;
export type CANT_DELETE_TASK_REASON = "BLOCKED_BY_SUBTASK" | "GITHUB" | "HAS_INVOICED_TIME" | "HAS_LOCKED_TIME" | "HAS_OTHER_PEOPLES_TIME_REGS" | "HAS_TIME_REGS" | "JIRA" | "NO_USER_TYPE" | "UNIT4" | "%future added value";
export type DEPENDENCY_TYPE = "CANNOT_BE_COMPLETED" | "CANNOT_START" | "%future added value";
export type PROGRAM_BUDGET_TYPE = "CAPPED" | "FIXED_PRICE" | "UNCAPPED" | "%future added value";
export type PROJECT_STATUS = "DONE" | "HALTED" | "OPPORTUNITY" | "PLANNING" | "RUNNING" | "%future added value";
export type STATUS_CATEGORY = "DONE" | "INPROGRESS" | "TODO" | "%future added value";
export type UpdateTaskInput = {|
  ids?: ?$ReadOnlyArray<?string>,
  projectId?: ?string,
  projectGroupId?: ?string,
  parentId?: ?string,
  phaseId?: ?string,
  aboveTaskId?: ?string,
  aboveFavouredTaskId?: ?string,
  name?: ?string,
  description?: ?string,
  estimateLow?: ?number,
  estimateHigh?: ?number,
  forecast?: ?number,
  timeLeft?: ?number,
  startYear?: ?number,
  startMonth?: ?number,
  startDay?: ?number,
  deadlineYear?: ?number,
  deadlineMonth?: ?number,
  deadlineDay?: ?number,
  roleId?: ?string,
  assignedPersons?: ?$ReadOnlyArray<?string>,
  unassignAllPersons?: ?boolean,
  assignedPersonToAdd?: ?string,
  followers?: ?$ReadOnlyArray<?string>,
  removeAllFollowers?: ?boolean,
  labels?: ?$ReadOnlyArray<?string>,
  clearAllLabels?: ?boolean,
  sprintId?: ?string,
  projectGroupSprintId?: ?string,
  statusColumnId?: ?string,
  statusColumnV2Id?: ?string,
  projectGroupStatusColumnId?: ?number,
  coverFileId?: ?string,
  blocked?: ?boolean,
  bug?: ?boolean,
  approved?: ?boolean,
  billable?: ?boolean,
  repeatingTaskId?: ?string,
  unassignedTaskId?: ?string,
  previousProjectId?: ?string,
  unassignPersonFromTask?: ?$ReadOnlyArray<?UnassignPersonFromTask>,
  remaining?: ?number,
  highPriority?: ?boolean,
  ownerId?: ?string,
  favoured?: ?boolean,
  favouredSortOrder?: ?string,
  parentTaskId?: ?string,
  previousParentTaskId?: ?string,
  isBulkContext?: ?boolean,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type UnassignPersonFromTask = {|
  taskId: string,
  personIds?: ?$ReadOnlyArray<?string>,
|};
export type reorderTaskMutationModernSprintMutationVariables = {|
  input: UpdateTaskInput
|};
export type reorderTaskMutationModernSprintMutationResponse = {|
  +updateTask: ?{|
    +errors: ?$ReadOnlyArray<?string>,
    +updatedTasksIds: ?$ReadOnlyArray<?string>,
    +childrenTasks: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +sprint: ?{|
            +id: string
          |},
          +phase: ?{|
            +id: string
          |},
          +deadlineDay: ?number,
          +deadlineMonth: ?number,
          +deadlineYear: ?number,
          +deadlineFrom: ?string,
          +startDay: ?number,
          +startMonth: ?number,
          +startYear: ?number,
          +startFrom: ?string,
        |}
      |}>
    |},
    +tasks: ?$ReadOnlyArray<?{|
      +id: string,
      +progress: ?number,
      +sortOrder: ?number,
      +favouredSortOrder: ?string,
      +phase: ?{|
        +id: string,
        +progress: ?number,
        +progressDetails: ?{|
          +progress: ?number
        |},
      |},
      +parentTaskId: ?string,
      +sprint: ?{|
        +id: string
      |},
      +statusColumnV2: ?{|
        +id: string
      |},
      +deadlineDay: ?number,
      +deadlineMonth: ?number,
      +deadlineYear: ?number,
      +startDay: ?number,
      +startMonth: ?number,
      +startYear: ?number,
      +done: ?boolean,
      +role: ?{|
        +id: string,
        +name: ?string,
      |},
      +assignedPersons: ?$ReadOnlyArray<?{|
        +id: string,
        +firstName: ?string,
        +lastName: ?string,
        +active: ?boolean,
        +email: ?string,
        +profilePictureId: ?string,
        +profilePictureDefaultId: ?number,
        +permissions: ?$ReadOnlyArray<?string>,
      |}>,
      +dependsOnThisTask: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +taskDependsOnThis: ?{|
              +id: string,
              +canStart: ?boolean,
              +canBeSetToDone: ?boolean,
            |},
          |}
        |}>
      |},
    |}>,
    +taskEdges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +userCanDeleteTask: ?boolean,
        +userCantDeleteTaskReason: ?CANT_DELETE_TASK_REASON,
        +fullAccessToProject: ?boolean,
        +approved: ?boolean,
        +name: ?string,
        +readOnly: ?{|
          +isReadOnly: ?boolean
        |},
        +coverFile: ?{|
          +id: string
        |},
        +parentTaskId: ?string,
        +parentTask: ?{|
          +id: string,
          +companyTaskId: ?number,
          +name: ?string,
          +parentTask: ?{|
            +id: string,
            +companyTaskId: ?number,
            +name: ?string,
          |},
        |},
        +hasChildren: ?boolean,
        +companyTaskId: ?number,
        +blocked: ?boolean,
        +bug: ?boolean,
        +billable: ?boolean,
        +highPriority: ?boolean,
        +startYear: ?number,
        +startMonth: ?number,
        +startDay: ?number,
        +description: ?string,
        +jiraId: ?string,
        +jiraKey: ?string,
        +gitlabIid: ?string,
        +vstsId: ?string,
        +pipedriveId: ?string,
        +isUnit4Task: ?boolean,
        +estimateForecast: ?number,
        +timeLeft: ?number,
        +deadlineDay: ?number,
        +deadlineMonth: ?number,
        +deadlineYear: ?number,
        +startFrom: ?string,
        +deadlineFrom: ?string,
        +gitlabServerIid: ?string,
        +hasLockedTime: ?boolean,
        +hasInvoicedTime: ?boolean,
        +favoured: ?boolean,
        +sageIntacctId: ?string,
        +progressDetails: ?{|
          +progress: ?number
        |},
        +followers: ?$ReadOnlyArray<?{|
          +id: string,
          +firstName: ?string,
          +lastName: ?string,
          +profilePictureId: ?string,
          +profilePictureDefaultId: ?number,
        |}>,
        +taskLabels: ?$ReadOnlyArray<?{|
          +label: ?{|
            +id: string,
            +name: ?string,
            +color: ?string,
          |}
        |}>,
        +subTasks: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +estimate: ?number,
              +done: ?boolean,
              +sortOrder: ?number,
              +name: ?string,
              +description: ?string,
              +startDay: ?number,
              +startMonth: ?number,
              +startYear: ?number,
              +endDay: ?number,
              +endMonth: ?number,
              +endYear: ?number,
              +startFrom: ?string,
              +endFrom: ?string,
              +role: ?{|
                +id: string,
                +name: ?string,
              |},
              +person: ?{|
                +id: string,
                +firstName: ?string,
                +lastName: ?string,
                +active: ?boolean,
                +profilePictureId: ?string,
                +profilePictureDefaultId: ?number,
              |},
            |}
          |}>
        |},
        +thisTaskDependsOn: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +type: ?DEPENDENCY_TYPE,
              +completed: ?boolean,
              +taskDependsOnThis: ?{|
                +id: string,
                +name: ?string,
                +companyTaskId: ?number,
                +startYear: ?number,
                +startMonth: ?number,
                +startDay: ?number,
                +deadlineDay: ?number,
                +deadlineMonth: ?number,
                +deadlineYear: ?number,
                +statusColumnV2: ?{|
                  +id: string,
                  +category: ?STATUS_CATEGORY,
                |},
              |},
              +thisDependsOnTask: ?{|
                +id: string,
                +name: ?string,
                +companyTaskId: ?number,
                +startYear: ?number,
                +startMonth: ?number,
                +startDay: ?number,
                +deadlineDay: ?number,
                +deadlineMonth: ?number,
                +deadlineYear: ?number,
                +statusColumnV2: ?{|
                  +id: string,
                  +category: ?STATUS_CATEGORY,
                |},
              |},
            |}
          |}>
        |},
        +dependsOnThisTask: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +type: ?DEPENDENCY_TYPE,
              +completed: ?boolean,
              +taskDependsOnThis: ?{|
                +id: string,
                +name: ?string,
                +companyTaskId: ?number,
                +startYear: ?number,
                +startMonth: ?number,
                +startDay: ?number,
                +deadlineDay: ?number,
                +deadlineMonth: ?number,
                +deadlineYear: ?number,
                +statusColumnV2: ?{|
                  +id: string,
                  +category: ?STATUS_CATEGORY,
                |},
              |},
              +thisDependsOnTask: ?{|
                +id: string,
                +name: ?string,
                +companyTaskId: ?number,
                +startYear: ?number,
                +startMonth: ?number,
                +startDay: ?number,
                +deadlineDay: ?number,
                +deadlineMonth: ?number,
                +deadlineYear: ?number,
                +statusColumnV2: ?{|
                  +id: string,
                  +category: ?STATUS_CATEGORY,
                |},
              |},
            |}
          |}>
        |},
        +repeatingTask: ?{|
          +id: string,
          +repeatType: ?string,
          +monday: ?boolean,
          +tuesday: ?boolean,
          +wednesday: ?boolean,
          +thursday: ?boolean,
          +friday: ?boolean,
          +saturday: ?boolean,
          +sunday: ?boolean,
          +monthlyDay: ?number,
        |},
        +statusColumnV2: ?{|
          +id: string,
          +name: ?string,
          +category: ?STATUS_CATEGORY,
          +projectGroupStatusColumnId: ?number,
        |},
        +phase: ?{|
          +id: string,
          +name: ?string,
          +startYear: ?number,
          +startMonth: ?number,
          +startDay: ?number,
          +deadlineDay: ?number,
          +deadlineMonth: ?number,
          +deadlineYear: ?number,
        |},
        +sprint: ?{|
          +id: string,
          +name: ?string,
          +startYear: ?number,
          +startMonth: ?number,
          +startDay: ?number,
          +endDay: ?number,
          +endMonth: ?number,
          +endYear: ?number,
        |},
        +assignedPersons: ?$ReadOnlyArray<?{|
          +id: string,
          +firstName: ?string,
          +lastName: ?string,
          +role: ?{|
            +id: string,
            +name: ?string,
          |},
          +profilePictureId: ?string,
          +profilePictureDefaultId: ?number,
          +email: ?string,
        |}>,
        +timeRegistrations: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +invoiced: ?boolean,
              +xeroInvoiceId: ?string,
              +minutesRegistered: ?number,
              +lockedInPeriod: ?boolean,
            |}
          |}>
        |},
        +role: ?{|
          +id: string,
          +name: ?string,
        |},
        +googleDriveFiles: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: ?string,
              +name: ?string,
              +link: ?string,
              +thumb: ?string,
            |}
          |}>
        |},
        +files: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +name: ?string,
              +mimeType: ?string,
              +key: ?string,
              +size: ?number,
              +yearCreated: ?number,
              +monthCreated: ?number,
              +dayCreated: ?number,
              +hourCreated: ?number,
              +minuteCreated: ?number,
              +secondCreated: ?number,
              +person: ?{|
                +id: string,
                +fullName: ?string,
              |},
            |}
          |}>
        |},
        +commentCount: ?number,
        +comments: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +comment: ?string,
              +year: ?number,
              +month: ?number,
              +day: ?number,
              +hours: ?number,
              +minutes: ?number,
              +seconds: ?number,
              +person: ?{|
                +id: string,
                +firstName: ?string,
                +lastName: ?string,
                +fullName: ?string,
                +profilePictureId: ?string,
                +profilePictureDefaultId: ?number,
              |},
            |}
          |}>
        |},
        +createdAt: ?string,
        +createdBy: ?{|
          +id: string,
          +firstName: ?string,
          +lastName: ?string,
        |},
        +latestUiUpdateAt: ?string,
        +latestUiUpdateBy: ?{|
          +id: string,
          +firstName: ?string,
          +lastName: ?string,
        |},
        +owner: ?{|
          +id: string,
          +firstName: ?string,
          +lastName: ?string,
          +fullName: ?string,
          +profilePictureId: ?string,
          +profilePictureDefaultId: ?number,
          +role: ?{|
            +id: string,
            +name: ?string,
          |},
        |},
        +project: ?{|
          +id: string,
          +name: ?string,
          +useTaskOwner: ?boolean,
          +useTaskFollowers: ?boolean,
          +useTaskHierarchy: ?boolean,
          +projectStartYear: ?number,
          +projectStartMonth: ?number,
          +projectStartDay: ?number,
          +projectEndYear: ?number,
          +projectEndMonth: ?number,
          +projectEndDay: ?number,
          +status: ?PROJECT_STATUS,
          +projectColor: ?string,
          +isJiraProject: ?boolean,
          +jiraSubtaskType: ?string,
          +jiraCloudProject: ?{|
            +id: string
          |},
          +jiraCloudEpicIds: ?$ReadOnlyArray<?string>,
          +jiraServerProject: ?{|
            +id: string
          |},
          +gitlabProjectName: ?string,
          +gitlabServerProjectName: ?string,
          +projectGroupId: ?string,
          +billable: ?boolean,
          +taskLevels: ?number,
          +companyProjectId: ?number,
          +customProjectId: ?string,
          +isProgramRevenueLocked: ?boolean,
          +programBudgetType: ?PROGRAM_BUDGET_TYPE,
          +program: ?{|
            +name: ?string,
            +prefix: ?string,
            +budgetType: ?PROGRAM_BUDGET_TYPE,
            +members: ?{|
              +edges: ?$ReadOnlyArray<?{|
                +node: ?{|
                  +role: ?string,
                  +person: ?{|
                    +id: string
                  |},
                |}
              |}>
            |},
          |},
          +harvestProject: ?{|
            +id: string
          |},
          +manualProgressOnProjectEnabled: ?boolean,
          +manualProgressOnPhasesEnabled: ?boolean,
          +manualProgressOnTasksEnabled: ?boolean,
          +vstsProject: ?string,
          +vstsAccount: ?string,
          +vstsTwoWaySync: ?boolean,
          +sprintTimeBox: ?boolean,
          +estimationUnit: ?string,
          +remainingAutoCalculated: ?boolean,
          +rateCard: ?{|
            +id: string,
            +disabledRoles: ?$ReadOnlyArray<?{|
              +id: string
            |}>,
          |},
          +projectPersons: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +person: ?{|
                  +id: string,
                  +firstName: ?string,
                  +lastName: ?string,
                  +fullName: ?string,
                  +profilePictureId: ?string,
                  +profilePictureDefaultId: ?number,
                  +active: ?boolean,
                  +permissions: ?$ReadOnlyArray<?string>,
                  +harvestUser: ?boolean,
                |},
                +project: ?{|
                  +id: string
                |},
                +role: ?{|
                  +id: string,
                  +name: ?string,
                |},
              |}
            |}>
          |},
          +client: ?{|
            +id: string,
            +name: ?string,
            +logoId: ?string,
            +logoDefaultId: ?number,
          |},
          +phases: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +name: ?string,
                +startYear: ?number,
                +startMonth: ?number,
                +startDay: ?number,
                +deadlineYear: ?number,
                +deadlineMonth: ?number,
                +deadlineDay: ?number,
              |}
            |}>
          |},
          +statusColumnsV2: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +name: ?string,
                +category: ?STATUS_CATEGORY,
                +order: ?number,
                +jiraStatusId: ?string,
                +adoState: ?string,
                +projectGroupStatusColumnId: ?number,
                +userActions: ?{|
                  +canDelete: ?boolean,
                  +canDeleteWithTasks: ?boolean,
                  +canCreateTask: ?boolean,
                  +canRename: ?boolean,
                |},
              |}
            |}>
          |},
          +sprints: ?{|
            +edges: ?$ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +name: ?string,
                +startYear: ?number,
                +startMonth: ?number,
                +startDay: ?number,
                +endYear: ?number,
                +endMonth: ?number,
                +endDay: ?number,
              |}
            |}>
          |},
          +completion: ?number,
          +remaining: ?number,
          +forecast: ?number,
          +$fragmentRefs: DeprecatedProjectIndicatorJS_project$ref,
        |},
        +done: ?boolean,
        +estimateForecastMinutes: ?number,
        +progress: ?number,
        +$fragmentRefs: DraggableCard_task$ref,
      |}
    |}>,
    +sortOrderTasks: ?$ReadOnlyArray<?{|
      +id: string,
      +sortOrder: ?number,
    |}>,
  |}
|};
export type reorderTaskMutationModernSprintMutation = {|
  variables: reorderTaskMutationModernSprintMutationVariables,
  response: reorderTaskMutationModernSprintMutationResponse,
|};
*/


/*
mutation reorderTaskMutationModernSprintMutation(
  $input: UpdateTaskInput!
) {
  updateTask(input: $input) {
    errors
    updatedTasksIds
    childrenTasks {
      edges {
        node {
          id
          sprint {
            id
          }
          phase {
            id
          }
          deadlineDay
          deadlineMonth
          deadlineYear
          deadlineFrom
          startDay
          startMonth
          startYear
          startFrom
        }
      }
    }
    tasks {
      id
      progress
      sortOrder
      favouredSortOrder
      phase {
        id
        progress
        progressDetails {
          progress
          id
        }
      }
      parentTaskId
      sprint {
        id
      }
      statusColumnV2 {
        id
      }
      deadlineDay
      deadlineMonth
      deadlineYear
      startDay
      startMonth
      startYear
      done
      role {
        id
        name
      }
      assignedPersons {
        id
        firstName
        lastName
        active
        email
        profilePictureId
        profilePictureDefaultId
        permissions
      }
      dependsOnThisTask(first: 1000) {
        edges {
          node {
            id
            taskDependsOnThis {
              id
              canStart
              canBeSetToDone
            }
            __typename
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
    taskEdges {
      node {
        ...DraggableCard_task
        id
        userCanDeleteTask
        userCantDeleteTaskReason
        fullAccessToProject
        approved
        name
        readOnly {
          isReadOnly
          id
        }
        coverFile {
          id
        }
        parentTaskId
        parentTask {
          id
          companyTaskId
          name
          parentTask {
            id
            companyTaskId
            name
          }
        }
        hasChildren
        companyTaskId
        blocked
        bug
        billable
        highPriority
        startYear
        startMonth
        startDay
        description
        jiraId
        jiraKey
        gitlabIid
        vstsId
        pipedriveId
        isUnit4Task
        estimateForecast
        timeLeft
        deadlineDay
        deadlineMonth
        deadlineYear
        startFrom
        deadlineFrom
        gitlabServerIid
        hasLockedTime
        hasInvoicedTime
        favoured
        sageIntacctId
        progressDetails {
          progress
          id
        }
        followers {
          id
          firstName
          lastName
          profilePictureId
          profilePictureDefaultId
        }
        taskLabels {
          label {
            id
            name
            color
          }
          id
        }
        subTasks(first: 1000) {
          edges {
            node {
              id
              estimate
              done
              sortOrder
              name
              description
              startDay
              startMonth
              startYear
              endDay
              endMonth
              endYear
              startFrom
              endFrom
              role {
                id
                name
              }
              person {
                id
                firstName
                lastName
                active
                profilePictureId
                profilePictureDefaultId
              }
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        thisTaskDependsOn(first: 1000) {
          edges {
            node {
              id
              type
              completed
              taskDependsOnThis {
                id
                name
                companyTaskId
                startYear
                startMonth
                startDay
                deadlineDay
                deadlineMonth
                deadlineYear
                statusColumnV2 {
                  id
                  category
                }
              }
              thisDependsOnTask {
                id
                name
                companyTaskId
                startYear
                startMonth
                startDay
                deadlineDay
                deadlineMonth
                deadlineYear
                statusColumnV2 {
                  id
                  category
                }
              }
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        dependsOnThisTask(first: 1000) {
          edges {
            node {
              id
              type
              completed
              taskDependsOnThis {
                id
                name
                companyTaskId
                startYear
                startMonth
                startDay
                deadlineDay
                deadlineMonth
                deadlineYear
                statusColumnV2 {
                  id
                  category
                }
              }
              thisDependsOnTask {
                id
                name
                companyTaskId
                startYear
                startMonth
                startDay
                deadlineDay
                deadlineMonth
                deadlineYear
                statusColumnV2 {
                  id
                  category
                }
              }
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        repeatingTask {
          id
          repeatType
          monday
          tuesday
          wednesday
          thursday
          friday
          saturday
          sunday
          monthlyDay
        }
        statusColumnV2 {
          id
          name
          category
          projectGroupStatusColumnId
        }
        phase {
          id
          name
          startYear
          startMonth
          startDay
          deadlineDay
          deadlineMonth
          deadlineYear
        }
        sprint {
          id
          name
          startYear
          startMonth
          startDay
          endDay
          endMonth
          endYear
        }
        assignedPersons {
          id
          firstName
          lastName
          role {
            id
            name
          }
          profilePictureId
          profilePictureDefaultId
          email
        }
        timeRegistrations(first: 5000) {
          edges {
            node {
              id
              invoiced
              xeroInvoiceId
              minutesRegistered
              lockedInPeriod
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        role {
          id
          name
        }
        googleDriveFiles(first: 10000) {
          edges {
            node {
              id
              name
              link
              thumb
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        files(first: 10000) {
          edges {
            node {
              id
              name
              mimeType
              key
              size
              yearCreated
              monthCreated
              dayCreated
              hourCreated
              minuteCreated
              secondCreated
              person {
                id
                fullName
              }
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        commentCount
        comments(first: 100000) {
          edges {
            node {
              id
              comment
              year
              month
              day
              hours
              minutes
              seconds
              person {
                id
                firstName
                lastName
                fullName
                profilePictureId
                profilePictureDefaultId
              }
              __typename
            }
            cursor
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
        createdAt
        createdBy {
          id
          firstName
          lastName
        }
        latestUiUpdateAt
        latestUiUpdateBy {
          id
          firstName
          lastName
        }
        owner {
          id
          firstName
          lastName
          fullName
          profilePictureId
          profilePictureDefaultId
          role {
            id
            name
          }
        }
        project {
          id
          name
          useTaskOwner
          useTaskFollowers
          useTaskHierarchy
          projectStartYear
          projectStartMonth
          projectStartDay
          projectEndYear
          projectEndMonth
          projectEndDay
          status
          projectColor
          isJiraProject
          jiraSubtaskType
          jiraCloudProject {
            id
          }
          jiraCloudEpicIds
          jiraServerProject {
            id
          }
          gitlabProjectName
          gitlabServerProjectName
          projectGroupId
          billable
          taskLevels
          companyProjectId
          customProjectId
          ...DeprecatedProjectIndicatorJS_project
          isProgramRevenueLocked
          programBudgetType
          program {
            name
            prefix
            budgetType
            members {
              edges {
                node {
                  role
                  person {
                    id
                  }
                  id
                }
              }
            }
            id
          }
          harvestProject {
            id
          }
          manualProgressOnProjectEnabled
          manualProgressOnPhasesEnabled
          manualProgressOnTasksEnabled
          vstsProject
          vstsAccount
          vstsTwoWaySync
          sprintTimeBox
          estimationUnit
          remainingAutoCalculated
          rateCard {
            id
            disabledRoles {
              id
            }
          }
          projectPersons(first: 10000) {
            edges {
              node {
                id
                person {
                  id
                  firstName
                  lastName
                  fullName
                  profilePictureId
                  profilePictureDefaultId
                  active
                  permissions
                  harvestUser
                }
                project {
                  id
                }
                role {
                  id
                  name
                }
                __typename
              }
              cursor
            }
            pageInfo {
              endCursor
              hasNextPage
            }
          }
          client {
            id
            name
            logoId
            logoDefaultId
          }
          phases(first: 10000) {
            edges {
              node {
                id
                name
                startYear
                startMonth
                startDay
                deadlineYear
                deadlineMonth
                deadlineDay
              }
            }
          }
          statusColumnsV2(first: 1000000) {
            edges {
              node {
                id
                name
                category
                order
                jiraStatusId
                adoState
                projectGroupStatusColumnId
                userActions {
                  canDelete
                  canDeleteWithTasks
                  canCreateTask
                  canRename
                  id
                }
              }
            }
          }
          sprints(first: 10000) {
            edges {
              node {
                id
                name
                startYear
                startMonth
                startDay
                endYear
                endMonth
                endDay
              }
            }
          }
          completion
          remaining
          forecast
        }
        done
        estimateForecastMinutes
        progress
      }
    }
    sortOrderTasks {
      id
      sortOrder
    }
  }
}

fragment DeprecatedProjectIndicatorJS_project on ProjectType {
  name
  companyProjectId
  customProjectId
  projectColor
}

fragment DraggableCard_task on Task {
  id
  billable
  latestUiUpdateAt
  description
  timeLeft
  progress
  favouredSortOrder
  estimateForecastMinutes
  totalMinutesRegistered
  companyTaskId
  readOnly {
    isReadOnly
    id
  }
  userCanDeleteTask
  userCantDeleteTaskReason
  hasChildren
  sageIntacctId
  name
  favoured
  highPriority
  bug
  blocked
  startDay
  startMonth
  startYear
  deadlineDay
  deadlineMonth
  jiraId
  vstsId
  deadlineYear
  subTaskCount
  fileCount
  commentCount
  done
  parentTaskId
  hasInvoicedTime
  role {
    id
    name
  }
  parentTask {
    name
    id
  }
  statusColumnV2 {
    id
    category
    projectGroupStatusColumnId
  }
  taskLabels {
    id
    label {
      id
      name
      color
    }
  }
  coverFile {
    id
    name
    key
  }
  project {
    id
    companyProjectId
    projectColor
    name
    status
    projectStartYear
    projectStartMonth
    projectStartDay
    projectEndYear
    projectEndMonth
    projectEndDay
    projectGroupId
    unit4Project {
      activitiesEnabled
      id
    }
    harvestProject {
      id
    }
    client {
      name
      logoId
      logoDefaultId
      id
    }
    isProgramRevenueLocked
    programBudgetType
    ...DeprecatedProjectIndicatorJS_project
  }
  thisTaskDependsOn(first: 1000) {
    edges {
      node {
        id
        type
        thisDependsOnTask {
          statusColumnV2 {
            category
            id
          }
          id
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  dependsOnThisTask(first: 1000) {
    edges {
      node {
        id
        type
        taskDependsOnThis {
          id
          statusColumnV2 {
            category
            id
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  assignedPersons {
    id
    firstName
    lastName
    fullName
    email
    profilePictureId
    profilePictureDefaultId
    active
    permissions
    role {
      id
      name
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateTaskInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedTasksIds",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Sprint",
  "kind": "LinkedField",
  "name": "sprint",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineDay",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineMonth",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineYear",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineFrom",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startFrom",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskTypeConnection",
  "kind": "LinkedField",
  "name": "childrenTasks",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Task",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v6/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "PhaseType",
              "kind": "LinkedField",
              "name": "phase",
              "plural": false,
              "selections": (v5/*: any*/),
              "storageKey": null
            },
            (v7/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/),
            (v12/*: any*/),
            (v13/*: any*/),
            (v14/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progress",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sortOrder",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "favouredSortOrder",
  "storageKey": null
},
v19 = [
  (v16/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentTaskId",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "StatusColumnV2",
  "kind": "LinkedField",
  "name": "statusColumnV2",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "done",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v23/*: any*/)
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureDefaultId",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "permissions",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "assignedPersons",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v25/*: any*/),
    (v26/*: any*/),
    (v27/*: any*/),
    (v28/*: any*/),
    (v29/*: any*/),
    (v30/*: any*/),
    (v31/*: any*/)
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "DependencyTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DependencyType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "taskDependsOnThis",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canStart",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canBeSetToDone",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v33/*: any*/)
        ],
        "storageKey": null
      },
      (v34/*: any*/)
    ],
    "storageKey": null
  },
  (v35/*: any*/)
],
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userCanDeleteTask",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userCantDeleteTaskReason",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullAccessToProject",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approved",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isReadOnly",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyTaskId",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "parentTask",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v42/*: any*/),
    (v23/*: any*/)
  ],
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasChildren",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blocked",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bug",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "highPriority",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraId",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraKey",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gitlabIid",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsId",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pipedriveId",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isUnit4Task",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimateForecast",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeLeft",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gitlabServerIid",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasLockedTime",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasInvoicedTime",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "favoured",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sageIntacctId",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "followers",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v25/*: any*/),
    (v26/*: any*/),
    (v29/*: any*/),
    (v30/*: any*/)
  ],
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "Label",
  "kind": "LinkedField",
  "name": "label",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v23/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDay",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endMonth",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endYear",
  "storageKey": null
},
v68 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SubTaskTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SubTask",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "estimate",
            "storageKey": null
          },
          (v22/*: any*/),
          (v17/*: any*/),
          (v23/*: any*/),
          (v49/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v65/*: any*/),
          (v66/*: any*/),
          (v67/*: any*/),
          (v14/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endFrom",
            "storageKey": null
          },
          (v24/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/)
            ],
            "storageKey": null
          },
          (v33/*: any*/)
        ],
        "storageKey": null
      },
      (v34/*: any*/)
    ],
    "storageKey": null
  },
  (v35/*: any*/)
],
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completed",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v72 = [
  (v4/*: any*/),
  (v23/*: any*/),
  (v42/*: any*/),
  (v13/*: any*/),
  (v12/*: any*/),
  (v11/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "StatusColumnV2",
    "kind": "LinkedField",
    "name": "statusColumnV2",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v71/*: any*/)
    ],
    "storageKey": null
  }
],
v73 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "taskDependsOnThis",
  "plural": false,
  "selections": (v72/*: any*/),
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "thisDependsOnTask",
  "plural": false,
  "selections": (v72/*: any*/),
  "storageKey": null
},
v75 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "DependencyTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DependencyType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v69/*: any*/),
          (v70/*: any*/),
          (v73/*: any*/),
          (v74/*: any*/),
          (v33/*: any*/)
        ],
        "storageKey": null
      },
      (v34/*: any*/)
    ],
    "storageKey": null
  },
  (v35/*: any*/)
],
v76 = {
  "alias": null,
  "args": null,
  "concreteType": "RepeatingTask",
  "kind": "LinkedField",
  "name": "repeatingTask",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "repeatType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "monday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tuesday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wednesday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thursday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "friday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "saturday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sunday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "monthlyDay",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectGroupStatusColumnId",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "concreteType": "PhaseType",
  "kind": "LinkedField",
  "name": "phase",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v23/*: any*/),
    (v13/*: any*/),
    (v12/*: any*/),
    (v11/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "concreteType": "Sprint",
  "kind": "LinkedField",
  "name": "sprint",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v23/*: any*/),
    (v13/*: any*/),
    (v12/*: any*/),
    (v11/*: any*/),
    (v65/*: any*/),
    (v66/*: any*/),
    (v67/*: any*/)
  ],
  "storageKey": null
},
v80 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TimeRegTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TimeRegType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiced",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "xeroInvoiceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minutesRegistered",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lockedInPeriod",
            "storageKey": null
          },
          (v33/*: any*/)
        ],
        "storageKey": null
      },
      (v34/*: any*/)
    ],
    "storageKey": null
  },
  (v35/*: any*/)
],
v81 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GoogleDriveFileTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GoogleDriveFile",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v23/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "link",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "thumb",
            "storageKey": null
          },
          (v33/*: any*/)
        ],
        "storageKey": null
      },
      (v34/*: any*/)
    ],
    "storageKey": null
  },
  (v35/*: any*/)
],
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v84 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FileTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "File",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v23/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mimeType",
            "storageKey": null
          },
          (v82/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "size",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "yearCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "monthCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dayCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hourCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minuteCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "secondCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v83/*: any*/)
            ],
            "storageKey": null
          },
          (v33/*: any*/)
        ],
        "storageKey": null
      },
      (v34/*: any*/)
    ],
    "storageKey": null
  },
  (v35/*: any*/)
],
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentCount",
  "storageKey": null
},
v86 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CommentTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CommentType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "comment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "year",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "month",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "day",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hours",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minutes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "seconds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v83/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/)
            ],
            "storageKey": null
          },
          (v33/*: any*/)
        ],
        "storageKey": null
      },
      (v34/*: any*/)
    ],
    "storageKey": null
  },
  (v35/*: any*/)
],
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v88 = [
  (v4/*: any*/),
  (v25/*: any*/),
  (v26/*: any*/)
],
v89 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v88/*: any*/),
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestUiUpdateAt",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "latestUiUpdateBy",
  "plural": false,
  "selections": (v88/*: any*/),
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v25/*: any*/),
    (v26/*: any*/),
    (v83/*: any*/),
    (v29/*: any*/),
    (v30/*: any*/),
    (v24/*: any*/)
  ],
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useTaskOwner",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useTaskFollowers",
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useTaskHierarchy",
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartYear",
  "storageKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartMonth",
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartDay",
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndYear",
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndMonth",
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndDay",
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isJiraProject",
  "storageKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraSubtaskType",
  "storageKey": null
},
v106 = {
  "alias": null,
  "args": null,
  "concreteType": "JiraCloudProjectType",
  "kind": "LinkedField",
  "name": "jiraCloudProject",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraCloudEpicIds",
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "concreteType": "JiraServerProjectType",
  "kind": "LinkedField",
  "name": "jiraServerProject",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v109 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gitlabProjectName",
  "storageKey": null
},
v110 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gitlabServerProjectName",
  "storageKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectGroupId",
  "storageKey": null
},
v112 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskLevels",
  "storageKey": null
},
v113 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v114 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customProjectId",
  "storageKey": null
},
v115 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isProgramRevenueLocked",
  "storageKey": null
},
v116 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "programBudgetType",
  "storageKey": null
},
v117 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prefix",
  "storageKey": null
},
v118 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budgetType",
  "storageKey": null
},
v119 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v120 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "person",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v121 = {
  "alias": null,
  "args": null,
  "concreteType": "HarvestProjectType",
  "kind": "LinkedField",
  "name": "harvestProject",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v122 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnProjectEnabled",
  "storageKey": null
},
v123 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnPhasesEnabled",
  "storageKey": null
},
v124 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnTasksEnabled",
  "storageKey": null
},
v125 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsProject",
  "storageKey": null
},
v126 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsAccount",
  "storageKey": null
},
v127 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsTwoWaySync",
  "storageKey": null
},
v128 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sprintTimeBox",
  "storageKey": null
},
v129 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimationUnit",
  "storageKey": null
},
v130 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remainingAutoCalculated",
  "storageKey": null
},
v131 = {
  "alias": null,
  "args": null,
  "concreteType": "RateCard",
  "kind": "LinkedField",
  "name": "rateCard",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Role",
      "kind": "LinkedField",
      "name": "disabledRoles",
      "plural": true,
      "selections": (v5/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v132 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProjectPersonTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectPerson",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v83/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v27/*: any*/),
              (v31/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "harvestUser",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": (v5/*: any*/),
            "storageKey": null
          },
          (v24/*: any*/),
          (v33/*: any*/)
        ],
        "storageKey": null
      },
      (v34/*: any*/)
    ],
    "storageKey": null
  },
  (v35/*: any*/)
],
v133 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoId",
  "storageKey": null
},
v134 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoDefaultId",
  "storageKey": null
},
v135 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v136 = {
  "alias": null,
  "args": (v135/*: any*/),
  "concreteType": "PhaseTypeConnection",
  "kind": "LinkedField",
  "name": "phases",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PhaseTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PhaseType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v23/*: any*/),
            (v13/*: any*/),
            (v12/*: any*/),
            (v11/*: any*/),
            (v9/*: any*/),
            (v8/*: any*/),
            (v7/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "phases(first:10000)"
},
v137 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000000
  }
],
v138 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "order",
  "storageKey": null
},
v139 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraStatusId",
  "storageKey": null
},
v140 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "adoState",
  "storageKey": null
},
v141 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canDelete",
  "storageKey": null
},
v142 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canDeleteWithTasks",
  "storageKey": null
},
v143 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canCreateTask",
  "storageKey": null
},
v144 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canRename",
  "storageKey": null
},
v145 = {
  "alias": null,
  "args": (v135/*: any*/),
  "concreteType": "SprintTypeConnection",
  "kind": "LinkedField",
  "name": "sprints",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SprintTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Sprint",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v23/*: any*/),
            (v13/*: any*/),
            (v12/*: any*/),
            (v11/*: any*/),
            (v67/*: any*/),
            (v66/*: any*/),
            (v65/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "sprints(first:10000)"
},
v146 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completion",
  "storageKey": null
},
v147 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remaining",
  "storageKey": null
},
v148 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "forecast",
  "storageKey": null
},
v149 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimateForecastMinutes",
  "storageKey": null
},
v150 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "sortOrderTasks",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v17/*: any*/)
  ],
  "storageKey": null
},
v151 = [
  (v16/*: any*/),
  (v4/*: any*/)
],
v152 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v153 = {
  "alias": null,
  "args": (v152/*: any*/),
  "filters": null,
  "handle": "connection",
  "key": "Task_dependsOnThisTask",
  "kind": "LinkedHandle",
  "name": "dependsOnThisTask"
},
v154 = {
  "alias": null,
  "args": null,
  "concreteType": "StatusColumnV2",
  "kind": "LinkedField",
  "name": "statusColumnV2",
  "plural": false,
  "selections": [
    (v71/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v155 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5000
  }
],
v156 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100000
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "reorderTaskMutationModernSprintMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateTaskPayload",
        "kind": "LinkedField",
        "name": "updateTask",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "tasks",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PhaseType",
                "kind": "LinkedField",
                "name": "phase",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhaseProgress",
                    "kind": "LinkedField",
                    "name": "progressDetails",
                    "plural": false,
                    "selections": (v19/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v20/*: any*/),
              (v6/*: any*/),
              (v21/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v22/*: any*/),
              (v24/*: any*/),
              (v32/*: any*/),
              {
                "alias": "dependsOnThisTask",
                "args": null,
                "concreteType": "DependencyTypeConnection",
                "kind": "LinkedField",
                "name": "__Task_dependsOnThisTask_connection",
                "plural": false,
                "selections": (v36/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskTypeEdge",
            "kind": "LinkedField",
            "name": "taskEdges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Task",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v37/*: any*/),
                  (v38/*: any*/),
                  (v39/*: any*/),
                  (v40/*: any*/),
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskReadOnly",
                    "kind": "LinkedField",
                    "name": "readOnly",
                    "plural": false,
                    "selections": [
                      (v41/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "coverFile",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Task",
                    "kind": "LinkedField",
                    "name": "parentTask",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v42/*: any*/),
                      (v23/*: any*/),
                      (v43/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v44/*: any*/),
                  (v42/*: any*/),
                  (v45/*: any*/),
                  (v46/*: any*/),
                  (v47/*: any*/),
                  (v48/*: any*/),
                  (v13/*: any*/),
                  (v12/*: any*/),
                  (v11/*: any*/),
                  (v49/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/),
                  (v52/*: any*/),
                  (v53/*: any*/),
                  (v54/*: any*/),
                  (v55/*: any*/),
                  (v56/*: any*/),
                  (v57/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v14/*: any*/),
                  (v10/*: any*/),
                  (v58/*: any*/),
                  (v59/*: any*/),
                  (v60/*: any*/),
                  (v61/*: any*/),
                  (v62/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskProgress",
                    "kind": "LinkedField",
                    "name": "progressDetails",
                    "plural": false,
                    "selections": (v19/*: any*/),
                    "storageKey": null
                  },
                  (v63/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskLabel",
                    "kind": "LinkedField",
                    "name": "taskLabels",
                    "plural": true,
                    "selections": [
                      (v64/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "subTasks",
                    "args": null,
                    "concreteType": "SubTaskTypeConnection",
                    "kind": "LinkedField",
                    "name": "__Task_subTasks_connection",
                    "plural": false,
                    "selections": (v68/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": "thisTaskDependsOn",
                    "args": null,
                    "concreteType": "DependencyTypeConnection",
                    "kind": "LinkedField",
                    "name": "__Task_thisTaskDependsOn_connection",
                    "plural": false,
                    "selections": (v75/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": "dependsOnThisTask",
                    "args": null,
                    "concreteType": "DependencyTypeConnection",
                    "kind": "LinkedField",
                    "name": "__Task_dependsOnThisTask_connection",
                    "plural": false,
                    "selections": (v75/*: any*/),
                    "storageKey": null
                  },
                  (v76/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StatusColumnV2",
                    "kind": "LinkedField",
                    "name": "statusColumnV2",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v23/*: any*/),
                      (v71/*: any*/),
                      (v77/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v78/*: any*/),
                  (v79/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Person",
                    "kind": "LinkedField",
                    "name": "assignedPersons",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v24/*: any*/),
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v28/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "timeRegistrations",
                    "args": null,
                    "concreteType": "TimeRegTypeConnection",
                    "kind": "LinkedField",
                    "name": "__Task_timeRegistrations_connection",
                    "plural": false,
                    "selections": (v80/*: any*/),
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  {
                    "alias": "googleDriveFiles",
                    "args": null,
                    "concreteType": "GoogleDriveFileTypeConnection",
                    "kind": "LinkedField",
                    "name": "__Task_googleDriveFiles_connection",
                    "plural": false,
                    "selections": (v81/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": "files",
                    "args": null,
                    "concreteType": "FileTypeConnection",
                    "kind": "LinkedField",
                    "name": "__Task_files_connection",
                    "plural": false,
                    "selections": (v84/*: any*/),
                    "storageKey": null
                  },
                  (v85/*: any*/),
                  {
                    "alias": "comments",
                    "args": null,
                    "concreteType": "CommentTypeConnection",
                    "kind": "LinkedField",
                    "name": "__Task_comments_connection",
                    "plural": false,
                    "selections": (v86/*: any*/),
                    "storageKey": null
                  },
                  (v87/*: any*/),
                  (v89/*: any*/),
                  (v90/*: any*/),
                  (v91/*: any*/),
                  (v92/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectType",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v23/*: any*/),
                      (v93/*: any*/),
                      (v94/*: any*/),
                      (v95/*: any*/),
                      (v96/*: any*/),
                      (v97/*: any*/),
                      (v98/*: any*/),
                      (v99/*: any*/),
                      (v100/*: any*/),
                      (v101/*: any*/),
                      (v102/*: any*/),
                      (v103/*: any*/),
                      (v104/*: any*/),
                      (v105/*: any*/),
                      (v106/*: any*/),
                      (v107/*: any*/),
                      (v108/*: any*/),
                      (v109/*: any*/),
                      (v110/*: any*/),
                      (v111/*: any*/),
                      (v47/*: any*/),
                      (v112/*: any*/),
                      (v113/*: any*/),
                      (v114/*: any*/),
                      (v115/*: any*/),
                      (v116/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProgramType",
                        "kind": "LinkedField",
                        "name": "program",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          (v117/*: any*/),
                          (v118/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectServiceProgramMemberTypeConnection",
                            "kind": "LinkedField",
                            "name": "members",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectServiceProgramMemberTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProjectServiceProgramMemberType",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v119/*: any*/),
                                      (v120/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v121/*: any*/),
                      (v122/*: any*/),
                      (v123/*: any*/),
                      (v124/*: any*/),
                      (v125/*: any*/),
                      (v126/*: any*/),
                      (v127/*: any*/),
                      (v128/*: any*/),
                      (v129/*: any*/),
                      (v130/*: any*/),
                      (v131/*: any*/),
                      {
                        "alias": "projectPersons",
                        "args": null,
                        "concreteType": "ProjectPersonTypeConnection",
                        "kind": "LinkedField",
                        "name": "__Project_projectPersons_connection",
                        "plural": false,
                        "selections": (v132/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Client",
                        "kind": "LinkedField",
                        "name": "client",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v23/*: any*/),
                          (v133/*: any*/),
                          (v134/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v136/*: any*/),
                      {
                        "alias": null,
                        "args": (v137/*: any*/),
                        "concreteType": "StatusColumnV2TypeConnection",
                        "kind": "LinkedField",
                        "name": "statusColumnsV2",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StatusColumnV2TypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StatusColumnV2",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v23/*: any*/),
                                  (v71/*: any*/),
                                  (v138/*: any*/),
                                  (v139/*: any*/),
                                  (v140/*: any*/),
                                  (v77/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StatusColumnUserActions",
                                    "kind": "LinkedField",
                                    "name": "userActions",
                                    "plural": false,
                                    "selections": [
                                      (v141/*: any*/),
                                      (v142/*: any*/),
                                      (v143/*: any*/),
                                      (v144/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "statusColumnsV2(first:1000000)"
                      },
                      (v145/*: any*/),
                      (v146/*: any*/),
                      (v147/*: any*/),
                      (v148/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "DeprecatedProjectIndicatorJS_project"
                      }
                    ],
                    "storageKey": null
                  },
                  (v22/*: any*/),
                  (v149/*: any*/),
                  (v16/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "DraggableCard_task"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v150/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "reorderTaskMutationModernSprintMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateTaskPayload",
        "kind": "LinkedField",
        "name": "updateTask",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "tasks",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PhaseType",
                "kind": "LinkedField",
                "name": "phase",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhaseProgress",
                    "kind": "LinkedField",
                    "name": "progressDetails",
                    "plural": false,
                    "selections": (v151/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v20/*: any*/),
              (v6/*: any*/),
              (v21/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v22/*: any*/),
              (v24/*: any*/),
              (v32/*: any*/),
              {
                "alias": null,
                "args": (v152/*: any*/),
                "concreteType": "DependencyTypeConnection",
                "kind": "LinkedField",
                "name": "dependsOnThisTask",
                "plural": false,
                "selections": (v36/*: any*/),
                "storageKey": "dependsOnThisTask(first:1000)"
              },
              (v153/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskTypeEdge",
            "kind": "LinkedField",
            "name": "taskEdges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Task",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v47/*: any*/),
                  (v90/*: any*/),
                  (v49/*: any*/),
                  (v57/*: any*/),
                  (v16/*: any*/),
                  (v18/*: any*/),
                  (v149/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalMinutesRegistered",
                    "storageKey": null
                  },
                  (v42/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskReadOnly",
                    "kind": "LinkedField",
                    "name": "readOnly",
                    "plural": false,
                    "selections": [
                      (v41/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v37/*: any*/),
                  (v38/*: any*/),
                  (v44/*: any*/),
                  (v62/*: any*/),
                  (v23/*: any*/),
                  (v61/*: any*/),
                  (v48/*: any*/),
                  (v46/*: any*/),
                  (v45/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v50/*: any*/),
                  (v53/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subTaskCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fileCount",
                    "storageKey": null
                  },
                  (v85/*: any*/),
                  (v22/*: any*/),
                  (v20/*: any*/),
                  (v60/*: any*/),
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Task",
                    "kind": "LinkedField",
                    "name": "parentTask",
                    "plural": false,
                    "selections": [
                      (v23/*: any*/),
                      (v4/*: any*/),
                      (v42/*: any*/),
                      (v43/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StatusColumnV2",
                    "kind": "LinkedField",
                    "name": "statusColumnV2",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v71/*: any*/),
                      (v77/*: any*/),
                      (v23/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskLabel",
                    "kind": "LinkedField",
                    "name": "taskLabels",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v64/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "coverFile",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v23/*: any*/),
                      (v82/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectType",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v113/*: any*/),
                      (v103/*: any*/),
                      (v23/*: any*/),
                      (v102/*: any*/),
                      (v96/*: any*/),
                      (v97/*: any*/),
                      (v98/*: any*/),
                      (v99/*: any*/),
                      (v100/*: any*/),
                      (v101/*: any*/),
                      (v111/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Unit4ProjectType",
                        "kind": "LinkedField",
                        "name": "unit4Project",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "activitiesEnabled",
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v121/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Client",
                        "kind": "LinkedField",
                        "name": "client",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          (v133/*: any*/),
                          (v134/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v115/*: any*/),
                      (v116/*: any*/),
                      (v114/*: any*/),
                      (v93/*: any*/),
                      (v94/*: any*/),
                      (v95/*: any*/),
                      (v104/*: any*/),
                      (v105/*: any*/),
                      (v106/*: any*/),
                      (v107/*: any*/),
                      (v108/*: any*/),
                      (v109/*: any*/),
                      (v110/*: any*/),
                      (v47/*: any*/),
                      (v112/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProgramType",
                        "kind": "LinkedField",
                        "name": "program",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          (v117/*: any*/),
                          (v118/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectServiceProgramMemberTypeConnection",
                            "kind": "LinkedField",
                            "name": "members",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectServiceProgramMemberTypeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProjectServiceProgramMemberType",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v119/*: any*/),
                                      (v120/*: any*/),
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v122/*: any*/),
                      (v123/*: any*/),
                      (v124/*: any*/),
                      (v125/*: any*/),
                      (v126/*: any*/),
                      (v127/*: any*/),
                      (v128/*: any*/),
                      (v129/*: any*/),
                      (v130/*: any*/),
                      (v131/*: any*/),
                      {
                        "alias": null,
                        "args": (v135/*: any*/),
                        "concreteType": "ProjectPersonTypeConnection",
                        "kind": "LinkedField",
                        "name": "projectPersons",
                        "plural": false,
                        "selections": (v132/*: any*/),
                        "storageKey": "projectPersons(first:10000)"
                      },
                      {
                        "alias": null,
                        "args": (v135/*: any*/),
                        "filters": [],
                        "handle": "connection",
                        "key": "Project_projectPersons",
                        "kind": "LinkedHandle",
                        "name": "projectPersons"
                      },
                      (v136/*: any*/),
                      {
                        "alias": null,
                        "args": (v137/*: any*/),
                        "concreteType": "StatusColumnV2TypeConnection",
                        "kind": "LinkedField",
                        "name": "statusColumnsV2",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StatusColumnV2TypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StatusColumnV2",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v23/*: any*/),
                                  (v71/*: any*/),
                                  (v138/*: any*/),
                                  (v139/*: any*/),
                                  (v140/*: any*/),
                                  (v77/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StatusColumnUserActions",
                                    "kind": "LinkedField",
                                    "name": "userActions",
                                    "plural": false,
                                    "selections": [
                                      (v141/*: any*/),
                                      (v142/*: any*/),
                                      (v143/*: any*/),
                                      (v144/*: any*/),
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "statusColumnsV2(first:1000000)"
                      },
                      (v145/*: any*/),
                      (v146/*: any*/),
                      (v147/*: any*/),
                      (v148/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v152/*: any*/),
                    "concreteType": "DependencyTypeConnection",
                    "kind": "LinkedField",
                    "name": "thisTaskDependsOn",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DependencyTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DependencyType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v69/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Task",
                                "kind": "LinkedField",
                                "name": "thisDependsOnTask",
                                "plural": false,
                                "selections": [
                                  (v154/*: any*/),
                                  (v4/*: any*/),
                                  (v23/*: any*/),
                                  (v42/*: any*/),
                                  (v13/*: any*/),
                                  (v12/*: any*/),
                                  (v11/*: any*/),
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  (v9/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v33/*: any*/),
                              (v70/*: any*/),
                              (v73/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v34/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v35/*: any*/)
                    ],
                    "storageKey": "thisTaskDependsOn(first:1000)"
                  },
                  {
                    "alias": null,
                    "args": (v152/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "Task_thisTaskDependsOn",
                    "kind": "LinkedHandle",
                    "name": "thisTaskDependsOn"
                  },
                  {
                    "alias": null,
                    "args": (v152/*: any*/),
                    "concreteType": "DependencyTypeConnection",
                    "kind": "LinkedField",
                    "name": "dependsOnThisTask",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DependencyTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DependencyType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v69/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Task",
                                "kind": "LinkedField",
                                "name": "taskDependsOnThis",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v154/*: any*/),
                                  (v23/*: any*/),
                                  (v42/*: any*/),
                                  (v13/*: any*/),
                                  (v12/*: any*/),
                                  (v11/*: any*/),
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  (v9/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v33/*: any*/),
                              (v70/*: any*/),
                              (v74/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v34/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v35/*: any*/)
                    ],
                    "storageKey": "dependsOnThisTask(first:1000)"
                  },
                  (v153/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Person",
                    "kind": "LinkedField",
                    "name": "assignedPersons",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v83/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v27/*: any*/),
                      (v31/*: any*/),
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v39/*: any*/),
                  (v40/*: any*/),
                  (v51/*: any*/),
                  (v52/*: any*/),
                  (v54/*: any*/),
                  (v55/*: any*/),
                  (v56/*: any*/),
                  (v14/*: any*/),
                  (v10/*: any*/),
                  (v58/*: any*/),
                  (v59/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TaskProgress",
                    "kind": "LinkedField",
                    "name": "progressDetails",
                    "plural": false,
                    "selections": (v151/*: any*/),
                    "storageKey": null
                  },
                  (v63/*: any*/),
                  {
                    "alias": null,
                    "args": (v152/*: any*/),
                    "concreteType": "SubTaskTypeConnection",
                    "kind": "LinkedField",
                    "name": "subTasks",
                    "plural": false,
                    "selections": (v68/*: any*/),
                    "storageKey": "subTasks(first:1000)"
                  },
                  {
                    "alias": null,
                    "args": (v152/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "Task_subTasks",
                    "kind": "LinkedHandle",
                    "name": "subTasks"
                  },
                  (v76/*: any*/),
                  (v78/*: any*/),
                  (v79/*: any*/),
                  {
                    "alias": null,
                    "args": (v155/*: any*/),
                    "concreteType": "TimeRegTypeConnection",
                    "kind": "LinkedField",
                    "name": "timeRegistrations",
                    "plural": false,
                    "selections": (v80/*: any*/),
                    "storageKey": "timeRegistrations(first:5000)"
                  },
                  {
                    "alias": null,
                    "args": (v155/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "Task_timeRegistrations",
                    "kind": "LinkedHandle",
                    "name": "timeRegistrations"
                  },
                  {
                    "alias": null,
                    "args": (v135/*: any*/),
                    "concreteType": "GoogleDriveFileTypeConnection",
                    "kind": "LinkedField",
                    "name": "googleDriveFiles",
                    "plural": false,
                    "selections": (v81/*: any*/),
                    "storageKey": "googleDriveFiles(first:10000)"
                  },
                  {
                    "alias": null,
                    "args": (v135/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "Task_googleDriveFiles",
                    "kind": "LinkedHandle",
                    "name": "googleDriveFiles"
                  },
                  {
                    "alias": null,
                    "args": (v135/*: any*/),
                    "concreteType": "FileTypeConnection",
                    "kind": "LinkedField",
                    "name": "files",
                    "plural": false,
                    "selections": (v84/*: any*/),
                    "storageKey": "files(first:10000)"
                  },
                  {
                    "alias": null,
                    "args": (v135/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "Task_files",
                    "kind": "LinkedHandle",
                    "name": "files"
                  },
                  {
                    "alias": null,
                    "args": (v156/*: any*/),
                    "concreteType": "CommentTypeConnection",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": (v86/*: any*/),
                    "storageKey": "comments(first:100000)"
                  },
                  {
                    "alias": null,
                    "args": (v156/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "Task_comments",
                    "kind": "LinkedHandle",
                    "name": "comments"
                  },
                  (v87/*: any*/),
                  (v89/*: any*/),
                  (v91/*: any*/),
                  (v92/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v150/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": null
        }
      ]
    },
    "name": "reorderTaskMutationModernSprintMutation",
    "operationKind": "mutation",
    "text": "mutation reorderTaskMutationModernSprintMutation(\n  $input: UpdateTaskInput!\n) {\n  updateTask(input: $input) {\n    errors\n    updatedTasksIds\n    childrenTasks {\n      edges {\n        node {\n          id\n          sprint {\n            id\n          }\n          phase {\n            id\n          }\n          deadlineDay\n          deadlineMonth\n          deadlineYear\n          deadlineFrom\n          startDay\n          startMonth\n          startYear\n          startFrom\n        }\n      }\n    }\n    tasks {\n      id\n      progress\n      sortOrder\n      favouredSortOrder\n      phase {\n        id\n        progress\n        progressDetails {\n          progress\n          id\n        }\n      }\n      parentTaskId\n      sprint {\n        id\n      }\n      statusColumnV2 {\n        id\n      }\n      deadlineDay\n      deadlineMonth\n      deadlineYear\n      startDay\n      startMonth\n      startYear\n      done\n      role {\n        id\n        name\n      }\n      assignedPersons {\n        id\n        firstName\n        lastName\n        active\n        email\n        profilePictureId\n        profilePictureDefaultId\n        permissions\n      }\n      dependsOnThisTask(first: 1000) {\n        edges {\n          node {\n            id\n            taskDependsOnThis {\n              id\n              canStart\n              canBeSetToDone\n            }\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n    taskEdges {\n      node {\n        ...DraggableCard_task\n        id\n        userCanDeleteTask\n        userCantDeleteTaskReason\n        fullAccessToProject\n        approved\n        name\n        readOnly {\n          isReadOnly\n          id\n        }\n        coverFile {\n          id\n        }\n        parentTaskId\n        parentTask {\n          id\n          companyTaskId\n          name\n          parentTask {\n            id\n            companyTaskId\n            name\n          }\n        }\n        hasChildren\n        companyTaskId\n        blocked\n        bug\n        billable\n        highPriority\n        startYear\n        startMonth\n        startDay\n        description\n        jiraId\n        jiraKey\n        gitlabIid\n        vstsId\n        pipedriveId\n        isUnit4Task\n        estimateForecast\n        timeLeft\n        deadlineDay\n        deadlineMonth\n        deadlineYear\n        startFrom\n        deadlineFrom\n        gitlabServerIid\n        hasLockedTime\n        hasInvoicedTime\n        favoured\n        sageIntacctId\n        progressDetails {\n          progress\n          id\n        }\n        followers {\n          id\n          firstName\n          lastName\n          profilePictureId\n          profilePictureDefaultId\n        }\n        taskLabels {\n          label {\n            id\n            name\n            color\n          }\n          id\n        }\n        subTasks(first: 1000) {\n          edges {\n            node {\n              id\n              estimate\n              done\n              sortOrder\n              name\n              description\n              startDay\n              startMonth\n              startYear\n              endDay\n              endMonth\n              endYear\n              startFrom\n              endFrom\n              role {\n                id\n                name\n              }\n              person {\n                id\n                firstName\n                lastName\n                active\n                profilePictureId\n                profilePictureDefaultId\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        thisTaskDependsOn(first: 1000) {\n          edges {\n            node {\n              id\n              type\n              completed\n              taskDependsOnThis {\n                id\n                name\n                companyTaskId\n                startYear\n                startMonth\n                startDay\n                deadlineDay\n                deadlineMonth\n                deadlineYear\n                statusColumnV2 {\n                  id\n                  category\n                }\n              }\n              thisDependsOnTask {\n                id\n                name\n                companyTaskId\n                startYear\n                startMonth\n                startDay\n                deadlineDay\n                deadlineMonth\n                deadlineYear\n                statusColumnV2 {\n                  id\n                  category\n                }\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        dependsOnThisTask(first: 1000) {\n          edges {\n            node {\n              id\n              type\n              completed\n              taskDependsOnThis {\n                id\n                name\n                companyTaskId\n                startYear\n                startMonth\n                startDay\n                deadlineDay\n                deadlineMonth\n                deadlineYear\n                statusColumnV2 {\n                  id\n                  category\n                }\n              }\n              thisDependsOnTask {\n                id\n                name\n                companyTaskId\n                startYear\n                startMonth\n                startDay\n                deadlineDay\n                deadlineMonth\n                deadlineYear\n                statusColumnV2 {\n                  id\n                  category\n                }\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        repeatingTask {\n          id\n          repeatType\n          monday\n          tuesday\n          wednesday\n          thursday\n          friday\n          saturday\n          sunday\n          monthlyDay\n        }\n        statusColumnV2 {\n          id\n          name\n          category\n          projectGroupStatusColumnId\n        }\n        phase {\n          id\n          name\n          startYear\n          startMonth\n          startDay\n          deadlineDay\n          deadlineMonth\n          deadlineYear\n        }\n        sprint {\n          id\n          name\n          startYear\n          startMonth\n          startDay\n          endDay\n          endMonth\n          endYear\n        }\n        assignedPersons {\n          id\n          firstName\n          lastName\n          role {\n            id\n            name\n          }\n          profilePictureId\n          profilePictureDefaultId\n          email\n        }\n        timeRegistrations(first: 5000) {\n          edges {\n            node {\n              id\n              invoiced\n              xeroInvoiceId\n              minutesRegistered\n              lockedInPeriod\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        role {\n          id\n          name\n        }\n        googleDriveFiles(first: 10000) {\n          edges {\n            node {\n              id\n              name\n              link\n              thumb\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        files(first: 10000) {\n          edges {\n            node {\n              id\n              name\n              mimeType\n              key\n              size\n              yearCreated\n              monthCreated\n              dayCreated\n              hourCreated\n              minuteCreated\n              secondCreated\n              person {\n                id\n                fullName\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        commentCount\n        comments(first: 100000) {\n          edges {\n            node {\n              id\n              comment\n              year\n              month\n              day\n              hours\n              minutes\n              seconds\n              person {\n                id\n                firstName\n                lastName\n                fullName\n                profilePictureId\n                profilePictureDefaultId\n              }\n              __typename\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n        createdAt\n        createdBy {\n          id\n          firstName\n          lastName\n        }\n        latestUiUpdateAt\n        latestUiUpdateBy {\n          id\n          firstName\n          lastName\n        }\n        owner {\n          id\n          firstName\n          lastName\n          fullName\n          profilePictureId\n          profilePictureDefaultId\n          role {\n            id\n            name\n          }\n        }\n        project {\n          id\n          name\n          useTaskOwner\n          useTaskFollowers\n          useTaskHierarchy\n          projectStartYear\n          projectStartMonth\n          projectStartDay\n          projectEndYear\n          projectEndMonth\n          projectEndDay\n          status\n          projectColor\n          isJiraProject\n          jiraSubtaskType\n          jiraCloudProject {\n            id\n          }\n          jiraCloudEpicIds\n          jiraServerProject {\n            id\n          }\n          gitlabProjectName\n          gitlabServerProjectName\n          projectGroupId\n          billable\n          taskLevels\n          companyProjectId\n          customProjectId\n          ...DeprecatedProjectIndicatorJS_project\n          isProgramRevenueLocked\n          programBudgetType\n          program {\n            name\n            prefix\n            budgetType\n            members {\n              edges {\n                node {\n                  role\n                  person {\n                    id\n                  }\n                  id\n                }\n              }\n            }\n            id\n          }\n          harvestProject {\n            id\n          }\n          manualProgressOnProjectEnabled\n          manualProgressOnPhasesEnabled\n          manualProgressOnTasksEnabled\n          vstsProject\n          vstsAccount\n          vstsTwoWaySync\n          sprintTimeBox\n          estimationUnit\n          remainingAutoCalculated\n          rateCard {\n            id\n            disabledRoles {\n              id\n            }\n          }\n          projectPersons(first: 10000) {\n            edges {\n              node {\n                id\n                person {\n                  id\n                  firstName\n                  lastName\n                  fullName\n                  profilePictureId\n                  profilePictureDefaultId\n                  active\n                  permissions\n                  harvestUser\n                }\n                project {\n                  id\n                }\n                role {\n                  id\n                  name\n                }\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n          client {\n            id\n            name\n            logoId\n            logoDefaultId\n          }\n          phases(first: 10000) {\n            edges {\n              node {\n                id\n                name\n                startYear\n                startMonth\n                startDay\n                deadlineYear\n                deadlineMonth\n                deadlineDay\n              }\n            }\n          }\n          statusColumnsV2(first: 1000000) {\n            edges {\n              node {\n                id\n                name\n                category\n                order\n                jiraStatusId\n                adoState\n                projectGroupStatusColumnId\n                userActions {\n                  canDelete\n                  canDeleteWithTasks\n                  canCreateTask\n                  canRename\n                  id\n                }\n              }\n            }\n          }\n          sprints(first: 10000) {\n            edges {\n              node {\n                id\n                name\n                startYear\n                startMonth\n                startDay\n                endYear\n                endMonth\n                endDay\n              }\n            }\n          }\n          completion\n          remaining\n          forecast\n        }\n        done\n        estimateForecastMinutes\n        progress\n      }\n    }\n    sortOrderTasks {\n      id\n      sortOrder\n    }\n  }\n}\n\nfragment DeprecatedProjectIndicatorJS_project on ProjectType {\n  name\n  companyProjectId\n  customProjectId\n  projectColor\n}\n\nfragment DraggableCard_task on Task {\n  id\n  billable\n  latestUiUpdateAt\n  description\n  timeLeft\n  progress\n  favouredSortOrder\n  estimateForecastMinutes\n  totalMinutesRegistered\n  companyTaskId\n  readOnly {\n    isReadOnly\n    id\n  }\n  userCanDeleteTask\n  userCantDeleteTaskReason\n  hasChildren\n  sageIntacctId\n  name\n  favoured\n  highPriority\n  bug\n  blocked\n  startDay\n  startMonth\n  startYear\n  deadlineDay\n  deadlineMonth\n  jiraId\n  vstsId\n  deadlineYear\n  subTaskCount\n  fileCount\n  commentCount\n  done\n  parentTaskId\n  hasInvoicedTime\n  role {\n    id\n    name\n  }\n  parentTask {\n    name\n    id\n  }\n  statusColumnV2 {\n    id\n    category\n    projectGroupStatusColumnId\n  }\n  taskLabels {\n    id\n    label {\n      id\n      name\n      color\n    }\n  }\n  coverFile {\n    id\n    name\n    key\n  }\n  project {\n    id\n    companyProjectId\n    projectColor\n    name\n    status\n    projectStartYear\n    projectStartMonth\n    projectStartDay\n    projectEndYear\n    projectEndMonth\n    projectEndDay\n    projectGroupId\n    unit4Project {\n      activitiesEnabled\n      id\n    }\n    harvestProject {\n      id\n    }\n    client {\n      name\n      logoId\n      logoDefaultId\n      id\n    }\n    isProgramRevenueLocked\n    programBudgetType\n    ...DeprecatedProjectIndicatorJS_project\n  }\n  thisTaskDependsOn(first: 1000) {\n    edges {\n      node {\n        id\n        type\n        thisDependsOnTask {\n          statusColumnV2 {\n            category\n            id\n          }\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  dependsOnThisTask(first: 1000) {\n    edges {\n      node {\n        id\n        type\n        taskDependsOnThis {\n          id\n          statusColumnV2 {\n            category\n            id\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  assignedPersons {\n    id\n    firstName\n    lastName\n    fullName\n    email\n    profilePictureId\n    profilePictureDefaultId\n    active\n    permissions\n    role {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6bfd1bce65a66533aab5b025c7a582d6';

module.exports = node;
